export const useFixedMoneyDecimals = () => {
    return (number: number) => {
        return number.toFixed(4);
    };
};
